"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepperController = void 0;
const react_1 = __importStar(require("react"));
const Step_1 = __importStar(require("./Step"));
const Stepper_style_1 = require("./Stepper.style");
class StepperController {
    constructor() {
        this.currentStep = 0;
    }
    setupController(stepperStepState, stepData) {
        this.stepperStepState = stepperStepState;
        this.stepData = stepData;
        this.currentStep = stepperStepState[0];
        this.setCurrentStep = stepperStepState[1];
    }
    previousStep() {
        if (this.stepData == null)
            return;
        const [currentStep, setCurrentStep] = this.stepperStepState;
        const newStep = Math.max(0, currentStep - 1);
        setCurrentStep(newStep);
        return newStep;
    }
    nextStep() {
        if (this.stepData == null)
            return;
        const len = this.stepData.length;
        const [currentStep, setCurrentStep] = this.stepperStepState;
        const newStep = Math.min(len - 1, currentStep + 1);
        setCurrentStep(newStep);
        return newStep;
    }
}
exports.StepperController = StepperController;
function Stepper({ currentStep: givenCurrentStep, stepData, stepperController, isMobile }) {
    const stepStateTp = react_1.useState(1);
    stepperController && stepperController.setupController(stepStateTp, stepData);
    //const [currentStep, setCurrentStep] = stepStateTp;
    const currentStep = stepperController ? stepperController.currentStep : givenCurrentStep;
    const Container = isMobile ? Stepper_style_1.StepperContainerMobile : Stepper_style_1.StepperContainer;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Container, null, stepData.map((stepData, index) => {
            let stepState = Step_1.StepState.todo;
            switch (true) {
                case currentStep > index:
                    stepState = Step_1.StepState.completed;
                    break;
                case currentStep == index:
                    stepState = Step_1.StepState.active;
                    break;
            }
            return react_1.default.createElement(Step_1.default, { key: index, number: index + 1, text: stepData.text, state: stepState, isMobile: isMobile });
        }))));
}
exports.default = Stepper;
